__turbopack_context__.v({
  "author": "ReviewsSlider-module-scss-module__fxQVPG__author",
  "authorInfo": "ReviewsSlider-module-scss-module__fxQVPG__authorInfo",
  "content": "ReviewsSlider-module-scss-module__fxQVPG__content",
  "image": "ReviewsSlider-module-scss-module__fxQVPG__image",
  "imageWrapper": "ReviewsSlider-module-scss-module__fxQVPG__imageWrapper",
  "name": "ReviewsSlider-module-scss-module__fxQVPG__name",
  "position": "ReviewsSlider-module-scss-module__fxQVPG__position",
  "slide": "ReviewsSlider-module-scss-module__fxQVPG__slide",
  "sliderWrapper": "ReviewsSlider-module-scss-module__fxQVPG__sliderWrapper",
  "swiper": "ReviewsSlider-module-scss-module__fxQVPG__swiper",
  "text": "ReviewsSlider-module-scss-module__fxQVPG__text",
});
